import React, { memo } from "react";

const QuestionInstruction = memo(function QuestionInstruction({
	subcategoryId, qTitle
}) {

	let instruction = "";
	switch (subcategoryId) {
		case 1:
			instruction = "Look at the text below. In 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
			break;
		case 2:
			instruction = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
			break;
		case 3:
			instruction = "Look at the image below. In 25 seconds, please speak into the microphone and describe in detail what the image is showing. You will have 40 seconds to give your response.";
			break;
		case 4:
			instruction = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
			break;
		case 5:
			instruction = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
			break;
		case 6:
			instruction = "Read the passage and summarise it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. Your response will be judged on the quality of your writing and on how well your response presents the key points in the passage.";
			break;
		case 7:
			instruction = "You will have 20 minutes to plan, write and revise an essay about the topic below. Your response will be judged on how well you develop a position, organize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
			break;
		case 8:
			instruction = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
			break;
		case 9:
			instruction = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
			break;
		case 10:
			instruction = "The text boxes in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
			break;
		case 11:
			instruction = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
			break;
		case 12:
			instruction = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
			break;
		case 13:
			instruction = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should write 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
			break;
		case 14:
			instruction = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
			break;
		case 15:
			instruction = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
			break;
		case 16:
			instruction = "You will hear a recording. Type the missing words in each blank.";
			break;
		case 17:
			instruction = "You will hear a recording. Click on the paragraph that best relates to the recording.";
			break;
		case 18:
			instruction = "You will hear a recording about "+ qTitle +". At the end of the recording the last word or group of words has been replaced by a beep. Select the correct option to complete the recording";
			break;
		case 19:
			instruction = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
			break;
		case 20:
			instruction = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
			break;
		case 21:
			instruction = "Listen to and read a description of a situation. You will have 10 seconds to think about your answer. Then you will hear a beep. You will have 40 seconds to answer the question. Please answer as completely as you can.";
			break;
		case 22:
			instruction = "You will hear three people having a discussion. When you hear the beep, summarize the whole discussion. You will have 10 seconds to prepare and 2 minutes to give your response.";
			break;
		default:
			// do nothing
	};

	return <>
	<div>
	<p className="question-title-ext">{instruction}</p>
	<hr />
	</div>
	</>
});

export default QuestionInstruction;